// layouts/Wrapper.jsx
import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../components/globals/headers/header";
import SubHeader from "../components/globals/headers/subHeader";
import DemoAddFooter from "../components/ads/demo-ad-footer/DemoAddFooter";

export default function Wrapper({
  headerSizes = { xl: 2, lg: 2, md: 2 },
  mainSizes = { xl: 10, lg: 10, md: 10 },
  className = "",
  children,
}) {
  const [headerWidth, setHeaderWidth] = useState(0);
  const elementRef = useRef(null);
  useEffect(() => {
    if (elementRef.current) {
      setHeaderWidth(elementRef.current.clientWidth - 10);
    }
  }, []);
  return (
    <>
      <div
        className={className}
        style={{
          background: "#F4F4F4",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        <Header elementRef={elementRef} />
        <div
          className="main_dashboard"
          style={{
            marginLeft: headerWidth + "px",
          }}
        >
          <SubHeader />
          <main
            style={{
              marginBottom: "100px",
            }}
          >
            {children}
          </main>
          <DemoAddFooter
            style={{
              left: headerWidth - 120 + "px",
            }}
          />
        </div>
      </div>
    </>
  );
}
